import React, {useEffect, useState} from 'react';
import Chart from "react-apexcharts";
import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";

import {getServiceMonitor} from "api/Api";

const ServiceDetailUsage = (props) => {
    const {serviceId, loading} = props;
    const [sendRequest, setSendRequest] = useState(true);
    const [localLoading, setLocalLoading] = useState(true);
    const [ramChart, setRamChart] = useState({
        show: false,
        series: [],
        options: {}
    });
    const [cpuChart, setCpuChart] = useState({
        show: false,
        series: [],
        options: {}
    });
    const [netReceivedChart, setNetReceivedChart] = useState({
        show: false,
        series: [],
        options: {}
    });
    const [netSentChart, setNetSentChart] = useState({
        show: false,
        series: [],
        options: {}
    });

    useEffect(() => {
        if (sendRequest) {
            if (!loading) {
                setSendRequest(false)
                getServiceMonitor(serviceId, (isOk, data) => {
                    if (isOk) {
                        // ram
                        try {
                            setRamChart({
                                show: Boolean(data.ram.length),
                                series: [{
                                    name: "ram usage (%)",
                                    data: data.ram.map(rm => parseFloat(Number(rm.mean).toFixed(2)))
                                }],
                                options: {
                                    chart: {
                                        height: 350,
                                        type: 'line',
                                        zoom: {
                                            enabled: false
                                        }
                                    },
                                    dataLabels: {
                                        enabled: false
                                    },
                                    stroke: {
                                        curve: 'smooth'
                                    },
                                    title: {
                                        text: '',
                                        align: 'left'
                                    },
                                    grid: {
                                        row: {
                                            colors: ['#f3f3f3', 'transparent'],
                                            opacity: 0.5
                                        },
                                    },
                                    xaxis: {
                                        categories: data.ram.map(rm => rm.time),
                                        labels: {
                                            show: false,
                                        },
                                    }
                                },
                            })
                        } catch (e) {
                            setRamChart({...ramChart, show: false})
                        }
                        // cpu
                        try {
                            setCpuChart({
                                show: Boolean(data.cpu.length),
                                series: [{
                                    name: "cpu usage (%)",
                                    data: data.cpu.map(rm => parseFloat(Number(rm.mean).toFixed(2)))
                                }],
                                options: {
                                    chart: {
                                        height: 350,
                                        type: 'line',
                                        zoom: {
                                            enabled: false
                                        }
                                    },
                                    dataLabels: {
                                        enabled: false
                                    },
                                    colors: ['#775dd0'],
                                    stroke: {
                                        curve: 'smooth'
                                    },
                                    title: {
                                        text: '',
                                        align: 'left'
                                    },
                                    grid: {
                                        row: {
                                            colors: ['#f3f3f3', 'transparent'],
                                            opacity: 0.5
                                        },
                                    },
                                    xaxis: {
                                        categories: data.cpu.map(rm => rm.time),
                                        labels: {
                                            show: false,
                                        },
                                    }
                                },
                            })
                        } catch (e) {
                            setCpuChart({...cpuChart, show: false})
                        }
                        // net received
                        try {
                            setNetReceivedChart({
                                show: Boolean(data.net_received.length),
                                series: [{
                                    name: "net received usage (Mb/s)",
                                    data: data.net_received.map(rm => parseFloat(Number(rm.mean).toFixed(2)))
                                }],
                                options: {
                                    chart: {
                                        height: 350,
                                        type: 'line',
                                        zoom: {
                                            enabled: false
                                        }
                                    },
                                    dataLabels: {
                                        enabled: false
                                    },
                                    colors: ['#00e396'],
                                    stroke: {
                                        curve: 'smooth',
                                        width: 5
                                    },
                                    title: {
                                        text: '',
                                        align: 'left'
                                    },
                                    grid: {

                                        row: {
                                            colors: ['transparent'],
                                            opacity: 0.5
                                        },
                                    },
                                    xaxis: {
                                        categories: data.net_received.map(rm => rm.time),
                                        labels: {
                                            show: false,
                                        },
                                    },
                                    yaxis: {
                                        show: true,
                                        showAlways: true
                                    }
                                },
                            })
                        } catch (e) {
                            setNetReceivedChart({...netReceivedChart, show: false})
                        }
                        // net sent
                        try {
                            setNetSentChart({
                                show: Boolean(data.net_sent.length),
                                series: [{
                                    name: "net sent usage (Mb/s)",
                                    data: data.net_sent.map(rm => parseFloat(Number(rm.mean).toFixed(2)))
                                }],
                                options: {
                                    chart: {
                                        height: 350,
                                        type: 'line',
                                        zoom: {
                                            enabled: false
                                        }
                                    },
                                    colors: ['#F44336'],
                                    dataLabels: {
                                        enabled: false
                                    },
                                    stroke: {
                                        curve: 'smooth'
                                    },
                                    title: {
                                        text: '',
                                        align: 'left'
                                    },
                                    grid: {
                                        row: {
                                            colors: ['#f3f3f3', 'transparent'],
                                            opacity: 0.5
                                        },
                                    },
                                    xaxis: {
                                        categories: data.net_sent.map(rm => rm.time),
                                        labels: {
                                            show: false,
                                        },
                                    },

                                },
                            })
                        } catch (e) {
                            setNetSentChart({...setNetSentChart, show: false})
                        }
                        //
                        setLocalLoading(false);
                    }
                })
            }
        }
    }, []);

    return (
        <>
            {
                localLoading ?
                    <div className="w-100 text-center">
                    <Box className={'mx-auto'}>
                        <CircularProgress/>
                    </Box>
                </div> : <div className="row direction-ltr">
                    {/* *** RAM *** */}
                    <div className="col-12 col-md-6 col-lg-3 mt-3">
                        <div>
                            <h5 className="m-0 text-center">RAM Usage (%)</h5>
                            <hr/>
                            {ramChart.show ?
                                <Chart options={ramChart?.options} series={ramChart?.series}
                                       type="line" height={350}/> :
                                <div className={"alert alert-warning"}>
                                    <h5 className={"m-0 text-center"}>داده ای برای نمایش وجود ندارد</h5>
                                </div>
                            }
                        </div>
                    </div>
                    {/* *** CPU *** */}
                    <div className="col-12 col-md-6 col-lg-3 mt-3">
                        <div>
                            <h5 className="m-0 text-center">CPU Usage (%)</h5>
                            <hr/>
                            {cpuChart.show ?
                                <Chart options={cpuChart?.options} series={cpuChart?.series}
                                       type="line" height={350}/> :
                                <div className={"alert alert-warning"}>
                                    <h5 className={"m-0 text-center"}>داده ای برای نمایش وجود ندارد</h5>
                                </div>
                            }
                        </div>
                    </div>
                    {/* *** NET RECEIVED *** */}
                    <div className="col-12 col-md-6 col-lg-3 mt-3">
                        <div>
                            <h5 className="m-0 text-center">Net Received Usage (Mb/s)</h5>
                            <hr/>
                            {netReceivedChart.show ?
                                <Chart options={netReceivedChart?.options} series={netReceivedChart?.series}
                                       type="line" height={350}/> :
                                <div className={"alert alert-warning"}>
                                    <h5 className={"m-0 text-center"}>داده ای برای نمایش وجود ندارد</h5>
                                </div>
                            }
                        </div>
                    </div>
                    {/* *** NET SENT *** */}
                    <div className="col-12 col-md-6 col-lg-3 mt-3">
                        <div>
                            <h5 className="m-0 text-center">Net Sent Usage (Mb/s)</h5>
                            <hr/>
                            {netSentChart.show ?
                                <Chart options={netSentChart?.options} series={netSentChart?.series}
                                       type="line" height={350}/> :
                                <div className={"alert alert-warning"}>
                                    <h5 className={"m-0 text-center"}>داده ای برای نمایش وجود ندارد</h5>
                                </div>
                            }
                        </div>
                    </div>
                </div>
            }
        </>
    )
}

export default ServiceDetailUsage;
